import { Order } from '@/types'
import { PDFDocument } from 'pdf-lib'

const mergePDFs = async (labels: string[]) => {
  // Create a new PDF document
  const mergedPdf = await PDFDocument.create()

  // Loop through each PDF and add pages to the merged document
  for (const label of labels) {
    const pdfBytes = Uint8Array.from(atob(label), (c) => c.charCodeAt(0))
    const pdf = await PDFDocument.load(pdfBytes)
    const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices())
    pages.forEach((page) => mergedPdf.addPage(page))
  }

  // Save the merged PDF
  const mergedPdfBytes = await mergedPdf.save()
  const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' })
  return URL.createObjectURL(blob)
}

const handleDownload = (url: string, uid: string) => {
  const link = document.createElement('a')

  link.href = url
  link.download = `[FRADA]-${uid}.pdf`
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadOrderLabels = async (order: Order) => {
  const url = await mergePDFs(order.labels.map((label) => (label as any).Data))
  handleDownload(url, order.uid)
}

export const getOrderTrackingUrl = (order: Order) => {
  switch (order.provider) {
    case 'GLS':
      return `https://gls-group.eu/track/${order.trackingNumbers[0]}`

    case 'Chronopost':
      return `https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${order.trackingNumbers.join(
        ','
      )}`
    default:
      return ''
  }
}
